import { render, staticRenderFns } from "./FacebookMessengerPreview.vue?vue&type=template&id=b2579a10&scoped=true&"
import script from "./FacebookMessengerPreview.vue?vue&type=script&lang=js&"
export * from "./FacebookMessengerPreview.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMessengerPreview.vue?vue&type=style&index=0&id=b2579a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2579a10",
  null
  
)

export default component.exports